export default "__VITE_ASSET__D72wweyO__"